import { render, staticRenderFns } from "./ManageFloatingIconDialog.vue?vue&type=template&id=cd8342f6&scoped=true"
import script from "./ManageFloatingIconDialog.vue?vue&type=script&lang=js"
export * from "./ManageFloatingIconDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageFloatingIconDialog.vue?vue&type=style&index=0&id=cd8342f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8342f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd8342f6')) {
      api.createRecord('cd8342f6', component.options)
    } else {
      api.reload('cd8342f6', component.options)
    }
    module.hot.accept("./ManageFloatingIconDialog.vue?vue&type=template&id=cd8342f6&scoped=true", function () {
      api.rerender('cd8342f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/operation/ad/components/ManageFloatingIconDialog.vue"
export default component.exports